export const BASE_URL = "https://impel.staging2.zooma.nl/api/v1";
export const FORGOT_PASSWORD_URL = "https://impel.staging2.zooma.nl/Security/lostpassword";
export const APP_VERSION = "1";
export const APP_VERSION_NAME = "web-dev";
export const DEBOUNCE_DELAY = 300;
